import {
  createFileRoute,
  Outlet,
  stripSearchParams,
} from "@tanstack/react-router";
import { getSubmission } from "api-client";
import { z } from "zod";

import { QuestionnaireSubmissionNavigation } from "src/components/QuesionnaireSubmissionNavigation";
import { loaderHandler } from "src/lib/loaderHandler";
import { QuestionnaireSubmissionContextProvider } from "src/questionnaire/QuestionnaireSubmissionContext";

const RouteSearchSchema = z.object({
  tab: z.union([z.literal("list"), z.literal("response")]).default("list"),
});

export const Route = createFileRoute(
  "/_auth/_coach/questionnaires/$questionnaireId/submissions/$submissionId",
)({
  component: RouteComponent,
  ssr: true,
  shouldReload: false,
  validateSearch: RouteSearchSchema,
  search: {
    middlewares: [stripSearchParams({ tab: "list" })],
  },
  async loader({ params }) {
    return await loaderHandler(async () => {
      const submission = await getSubmission({
        path: { submissionId: params.submissionId },
      }).then((res) => {
        return res.data.data;
      });

      return {
        data: {
          submission,
        },
      };
    });
  },
});

function RouteComponent() {
  const { data } = Route.useLoaderData();
  return (
    <>
      <QuestionnaireSubmissionNavigation
        submission={data.submission}
        prevLinkProps={{
          to: "/questionnaires/$questionnaireId/submissions/$submissionId",
          search: { tab: "response" },
          params: {
            questionnaireId: data.submission.questionnaire.id,
            submissionId: data.submission.navigation.previousSubmissionId ?? "",
          },
        }}
        nextLinkProps={{
          to: "/questionnaires/$questionnaireId/submissions/$submissionId",
          search: { tab: "response" },
          params: {
            questionnaireId: data.submission.questionnaire.id,
            submissionId: data.submission.navigation.nextSubmissionId ?? "",
          },
        }}
      />
      <QuestionnaireSubmissionContextProvider
        key={data.submission.id}
        questionnaireSubmission={data.submission}
      >
        <Outlet></Outlet>
      </QuestionnaireSubmissionContextProvider>
    </>
  );
}
